import { Component, Inject, OnInit, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';


import { NgcCookieConsentService, NgcInitializingEvent, NgcNoCookieLawEvent, NgcStatusChangeEvent } from 'ngx-cookieconsent';

import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit{

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
}

  //keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription: Subscription = new Subscription();
  private popupCloseSubscription: Subscription = new Subscription();
  //private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription = new Subscription();
  private revokeChoiceSubscription: Subscription = new Subscription();
  private noCookieLawSubscription: Subscription = new Subscription();
  public cookieConsent = true;

  constructor(private ccService: NgcCookieConsentService, private translateService:TranslateService, private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
 
  }

  acceptCookies(){
    document.cookie = `cookieAccepted=true;Secure; max-age=${365 * 86400}; path=/;`;
    this.cookieConsent = false;
    }

    ngOnInit() {
      // subscribe to cookieconsent observables to react to main events
      if(document.cookie.indexOf('cookieAccepted') < 0){
       this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
        () => {
          // you can use this.ccService.getConfig() to do stuff...
          console.log('popupOpen');
        });
        this.cookieConsent = true;
      }
  else {
    this.cookieConsent = false;
  }
  
  
      this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
        () => {
          // you can use this.ccService.getConfig() to do stuff...
          console.log('popuClose');
        });
  
      // this.initializeSubscription = this.ccService?.initialized$.subscribe(
      //   (event: NgcInitializingEvent) => {
      //     // you can use this.ccService.getConfig() to do stuff...
      //     console.log(`initialize: ${JSON.stringify(event)}`);
      //   });
  
      this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
        (event: NgcStatusChangeEvent) => {
          // you can use this.ccService.getConfig() to do stuff...
          // console.log(`statusChange: ${JSON.stringify(event)}`);
          if (event.status === 'deny') {
            this.openCookies();
          }
        });
  
      
  
      this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
        () => {
          // you can use this.ccService.getConfig() to do stuff...
          console.log(`revokeChoice`);
        });
  
      this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
        (event: NgcNoCookieLawEvent) => {
          // you can use this.ccService.getConfig() to do stuff...
          console.log(`noCookieLaw: ${JSON.stringify(event)}`);
        });
  
  
      // (Optional) support for translated cookies messages
      this.translateService.addLangs(['en', 'fr']);
      this.translateService.setDefaultLang('en');
    }
    openCookies() {
      throw new Error('Method not implemented.');
    }

  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    //this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
}
